import { mergeStyleSets } from '@fluentui/react';
import styled, { StyleSheetManager } from 'styled-components';

export const modalStyles = mergeStyleSets({
  container: {
    display: 'flex',
    borderRadius: 16,
    width: 1000,
    padding: '32px 16px',
    boxShadow: 'inset 0 6px 0 0 #FD6262, 1px 1px 8px rgba(0, 0, 0, 0.05)',
  },
});

export const SpeakerModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  /* height: 500px; */
  max-height: 100%;
`;

export const SpeakerModalHeader = styled.div`
  position: relative;
  display: flex;
  gap: 16px;
  padding: 0 20px 20px;
  align-items: center;

  h1 {
    font: 700 1.5rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.black};
  }

  h2 {
    border-left: 1px solid #dfdfdf;
    padding-left: 12px;
    font: 400 0.9rem/1.8rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.neutralSecondary};
  }

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    opacity: 0.1;
    background: ${({ theme }: {theme: any}) => theme.black};
  }
`;

export const SpeakersTableContainer = styled.div`
  display: flex;
  height: 400px;
  width: 100%;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 20px;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #d6dee1;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #a8bbbf;
  }
`;

export const SpeakerFiltersContainer = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1.2fr 1fr 1fr 2fr;
  gap: 1rem;

  > div {
    margin: 0 1px;
  }

  > .skeleton {
    height: 100%;
    width: 100%;
    background: ${({ theme }: {theme: any}) => theme.neutralQuaternaryAlt};
    display: flex;
    border-radius: 1rem;
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  span {
    font: 700 0.7rem/1rem 'Roboto', sans-serif;
    color: ${({ theme }: {theme: any}) => theme.themeDark};
  }

  input {
    padding: 0 0.5rem;
    font: 300 0.8rem/1rem 'Roboto', sans-serif;
    height: 100%;
    border: 1px solid ${({ theme }: {theme: any}) => theme.white};
    color: ${({ theme }: {theme: any}) => theme.black};
    background-color: ${({ theme }: {theme: any}) => theme.neutralLighter};
    border-radius: 5px;

    &::placeholder {
      color: ${({ theme }: {theme: any}) => theme.black};
    }

    &:focus {
      border: 2px solid ${({ theme }: {theme: any}) => theme.themePrimary};
    }
  }
`;
